import * as Yup from 'yup';
import { filter, truncate } from 'lodash';
import ReactDOM from 'react-dom';
import QRCode from 'react-qr-code';
import { Icon } from '@iconify/react';
import { sentenceCase } from 'change-case';
import { useState, useEffect, useRef } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import settingsOutline from '@iconify/icons-eva/settings-outline';
import questionMarkCircleOutline from '@iconify/icons-eva/question-mark-circle-outline';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { useTheme } from '@material-ui/core/styles';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  Switch,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Grid,
  TextField,
  Autocomplete,
  Box,
  CircularProgress,
  Tooltip,
  IconButton,

} from '@material-ui/core';
// redux
import { useDispatch, useSelector } from '../../redux/store';
import { getUserList, deleteUser } from '../../redux/slices/user';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import Page from '../../components/Page';
import LoadingScreen from 'src/components/LoadingScreen';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../../components/_dashboard/user/list';
import  ProductToolbar  from 'src/components/_dashboard/user/list/ProductToolbar.js';
import  ProductsSearch  from 'src/components/_dashboard/blog/ProductsSearch.js';
import  ProductsMenu  from 'src/components/_dashboard/user/list/ProductsMenu.js';
import axios from 'axios';
import {BASE_URL, REST_API, REST_API_END_POINT, UNITS} from '../../constants/Defaultvalues';
import moment from 'moment';
import MaterialInventoryMenu from 'src/components/_dashboard/user/list/MaterialInventoryMenu';
import MaterialInventoryToolbar from 'src/components/_dashboard/user/list/MaterialInventoryToolbar';
import Modal from 'src/components/_dashboard/blog/ProjectModel';
import ReactToPrint from 'react-to-print';
import { Form, FormikProvider, useFormik } from 'formik';
import { LoadingButton } from '@material-ui/lab';
import { useSnackbar } from 'notistack';
import { stubTrue } from 'lodash';
import FinishedProductmenu from 'src/components/_dashboard/blog/FinishedProductmenu';
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons';
import InventoryStockComparison from 'src/components/_dashboard/receive-inventory/InventoryStockComparison';
import InventoryUnitCostWarningDialog from 'src/components/_dashboard/inventory/InventoryUnitCostWarningDialog';
import {
  getConvertionQtyRefillWarningContent,
  isFinishedConvertionQtyChange,
  isUnitCostOnlyChange,
} from 'src/utils/inventoryUnitCostWarning';

export default function MaterialFinishedProducts({prodId,materialTab , viewFinishedProducts, unitName, unit, unitQty,expectedPrice,retailMarkup,vpt_number,viewData,description,hideMoveToPartial,isCatalog,fromTask,fromListTransfer}) {
  const theme = useTheme();
  const componentRef = useRef();
  const dispatch = useDispatch();
  const location = useLocation();
  // const searchParams = new URLSearchParams(location.search);
  // const id = searchParams.get('id');
  const editId = parseInt(prodId);
  const [loading, setLoading] = useState(false)
  const [refreshData, setRefreshData] = useState(false)
  const [editFinishedProductId, setEditFinishedProductId] = useState()
  const [editData, setEditData] = useState([])
  const [openAddFinishedProduct, setOpenAddFinishedProduct] = useState(false)
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [selectedNames, setSelectedNames] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [filterSource, setFilterSource] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [ProductList, setProductList] = useState([]);
  const receivedData = location.state?.data;
  const { enqueueSnackbar } = useSnackbar();
  const userData = JSON.parse(localStorage.getItem('user'))
  const userId = userData.user_id
  const explodedPermissions =userData?.exploded_permissions
  const tableContainerRef = useRef(null);
  console.log("descriptiondescription 111",description)
  const [printerSettings, setPrinterSettings] = useState(false)
  const [showUnitCostWarningDialog, setShowUnitCostWarningDialog] = useState(false)
  const skipUnitCostWarningRef = useRef(false)
  const [showConvertionQtyWarningDialog, setShowConvertionQtyWarningDialog] = useState(false)
  const skipConvertionQtyWarningRef = useRef(false)
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: '', label: '', alignRight: false },
  { id: 'qrcode', label: 'QR Code', alignRight: false },
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'costPerUnitMeasure', label: 'Cost Per Unit Measure', alignRight: false },
  { id: 'sales_price', label: fromTask ? '' : 'Sales Price', alignRight: false },
  { id: 'unit_cost', label:fromTask ? '' : `${unitName} Cost`, alignRight: false },
  // { id: 'unit_qty', label: 'Quantity', alignRight: false },
  { id: 'qty', label: `Total ${unitName}`, alignRight: false },
  { id: 'total_cost', label: fromTask ? '' : 'Total Cost', alignRight: false },
  { id: 'source', label:fromTask ? '' : 'Source', alignRight: false },
  { id: 'vendor', label:fromTask ? '' : 'Vendor Name', alignRight: false },
  // { id: 'timestamp', label: 'Added On', alignRight: false },
  { id: 'avaliable_partial', label: 'Partial Stock', alignRight: false },
  { id: 'status', label: 'Print Labels', alignRight: false },
  { id:'options', label: '', alignRight: false},      
  { id:'options', label: '', alignRight: false},      
];

// ----------------------------------------------------------------------

  useEffect(() => {
    dispatch(getUserList());
  }, [dispatch]);

  useEffect( async () => {
    setLoading(true)
    try {
      const response = await axios.post(`${REST_API_END_POINT}product/get-finished-products`,{editId});
      const productListData = response.data.results;
      if(productListData){
        setProductList(productListData);
        // console.log("productListData : ",productListData);
      }
      else{
        setProductList([]);
      }
    }catch (error) {
      console.error("Error fetching data:", error);
      setProductList([]);
    }
    finally{
      setLoading(false);
    }
  }, [receivedData, refreshData]);

  const fetchDataById = async () => {
    try{
      const response = await axios.post(`${REST_API_END_POINT}product/get-finished-product-by-id`,{editFinishedProductId});
      if(response.data.status === 1) {
        setEditData(response.data.results[0])
      }
      else{
        setEditData([])
      }
    }catch(error){
      console.log(error);
    }
  }

  useEffect(()=>{
    if(editFinishedProductId){
      fetchDataById()
    }
  },[editFinishedProductId])

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  
  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  
  function applySortFilter(array, comparator, query, source) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    if (query) {
      return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }
    if (source) {
      if (source === 'Inventory') {
        return filter(array, (_user) => _user.source === 0);
      }
      else if (source === 'Vendor') {
        return filter(array, (_user) => _user.source === 1);
      }
    }
    return stabilizedThis.map((el) => el[0]);
  }
  
  const NewCommunitySchema = Yup.object().shape({
    unitCost: Yup.number().typeError('Please enter a valid price').required(`Please enter the ${unitName} cost`),
    qty: Yup.number()
      .transform((value, originalValue) => (originalValue === '' ? undefined : value))
      .typeError('Please enter a valid qty')
      .min(0, 'Quantity must be 0 or greater')
      .notRequired(),
    convertionUnit: Yup.object().nullable().required('Conversion unit is required'),
    convertionQty: Yup.number()
      .transform((value, originalValue) => (originalValue === '' ? undefined : value))
      .when(['convertionUnit'], {
        is: (convertionUnit) =>
          convertionUnit && convertionUnit.id !== 4 && convertionUnit.name !== 'Unit',
        then: (schema) =>
          schema
            .typeError('Please enter a valid conversion qty')
            .moreThan(0, 'Conversion qty must be greater than 0')
            .required('Conversion qty is required'),
        otherwise: (schema) => schema.notRequired(),
      }),
    inventoryReason: Yup.string().when([], {
      is: () => Boolean(editFinishedProductId),
      then: (schema) => schema.trim().required('Reason is required'),
      otherwise: (schema) => schema.notRequired()
    })
  });
  
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      unitCost: (editFinishedProductId && editData) ? editData.unit_cost : expectedPrice || 0,
      qty: (editFinishedProductId && editData) ? editData.unit_qty || editData.qty : 0,
      total: (editFinishedProductId && editData) ? editData.total_cost : 0,
      convertionUnit:
        (editFinishedProductId && editData?.convertion_unit)
          ? UNITS?.find((item) => item.id === editData.convertion_unit) || null
          : null,
      convertionQty: (editFinishedProductId && editData) ? (editData.convertion_qty ?? '') : 0,
      inventoryReason: '',
    },
    validationSchema: NewCommunitySchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors, setFieldError }) => {
      if (
        !skipUnitCostWarningRef.current &&
        isUnitCostOnlyChange(values, editData, editFinishedProductId)
      ) {
        setShowUnitCostWarningDialog(true);
        setSubmitting(false);
        return;
      }
      skipUnitCostWarningRef.current = false;

      if (
        !skipConvertionQtyWarningRef.current &&
        isFinishedConvertionQtyChange(values, editData, editFinishedProductId)
      ) {
        setShowConvertionQtyWarningDialog(true);
        setSubmitting(false);
        return;
      }
      skipConvertionQtyWarningRef.current = false;

      try {
        let response = '';
        const normalizedQty = values.qty === '' || values.qty === null || values.qty === undefined
          ? 0
          : parseInt(values.qty, 10) || 0;
        const isBaseConversionUnitOnSubmit =
          values.convertionUnit?.id === 4 || values.convertionUnit?.name === 'Unit';
        const normalizedConvertionQty = isBaseConversionUnitOnSubmit
          ? parseInt(values.convertionQty, 10) || 1
          : parseInt(values.convertionQty, 10) || 0;
        const normalizedTotal = normalizedQty === 0
          ? '0.00'
          : values.total;
        const payloadValues = {
          ...values,
          qty: normalizedQty,
          total: normalizedTotal,
          convertion_unit: values.convertionUnit?.id || null,
          convertion_qty: normalizedConvertionQty,
          convertion_total_qty: normalizedQty * normalizedConvertionQty
        };
        if(editFinishedProductId){
          const materialName = editData?.product_name
          const editBarcode = editData?.barcode
          const partial = editData?.partial
          response = await axios.post(`${REST_API_END_POINT}product/update-inventory`, {
            values: payloadValues,
            userId,
            editFinishedProductId,
            editId,
            materialName,
            editBarcode,
            partial,
            auditTotalQtyLabel:
              editData?.partial === 1 && values?.convertionUnit?.short_name
                ? `Total ${values.convertionUnit.short_name} Qty`
                : undefined,
            auditFinishedTotalQtyLabel:
              editData?.partial !== 1 && values?.convertionUnit?.short_name
                ? `Total ${values.convertionUnit.short_name} Qty`
                : undefined,
          })
        }else{
          if(unitName === 'Unit') {
            payloadValues.qty = normalizedQty
            payloadValues.unit_qty = normalizedQty
          }else{
            payloadValues.unit_qty = normalizedQty
            payloadValues.qty = normalizedQty * unitQty
          }
          response = await axios.post(`${REST_API_END_POINT}product/add-finished-product`, {values: payloadValues,userId,editId,isCatalog})
        }
        // console.log("Edit community type response : ", response.data);
        if (response.data.status === 1) {
          enqueueSnackbar(response.data.message, { variant: 'success' });
          resetForm();
          setSubmitting(false);
          setOpenAddFinishedProduct(false)
          setEditData([])
          setEditFinishedProductId()
          setRefreshData(!refreshData)
        }
        else {
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
      } catch (error) {
        console.error("Error : ", error);
        setSubmitting(false);
        setErrors(error);
      }
    }
  });
  
  const handleScrollLeft = () => {
    tableContainerRef.current.scrollTo({
      left: 0,
      behavior: 'smooth'
    });
  };
  
  const handleScrollRight = () => {
    tableContainerRef.current.scrollTo({
      left: tableContainerRef.current.scrollWidth,
      behavior: 'smooth'
    });
  };

  const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps, submitForm } = formik;

  const handleConfirmUnitCostWarning = () => {
    setShowUnitCostWarningDialog(false);
    skipUnitCostWarningRef.current = true;
    submitForm();
  };

  const handleConfirmConvertionQtyWarning = () => {
    setShowConvertionQtyWarningDialog(false);
    skipConvertionQtyWarningRef.current = true;
    submitForm();
  };

  const convertionQtyWarningContent = getConvertionQtyRefillWarningContent(values, editData);

  const handleCloseFinishedProductModal = () => {
    setOpenAddFinishedProduct(false);
    setShowUnitCostWarningDialog(false);
    setShowConvertionQtyWarningDialog(false);
    skipUnitCostWarningRef.current = false;
    skipConvertionQtyWarningRef.current = false;
    setEditFinishedProductId();
    setEditData([]);
    formik.resetForm();
  };

  const handleOpenAddFinishedProduct = () => {
    setEditFinishedProductId();
    setEditData([]);
    setShowUnitCostWarningDialog(false);
    setShowConvertionQtyWarningDialog(false);
    skipUnitCostWarningRef.current = false;
    skipConvertionQtyWarningRef.current = false;
    setOpenAddFinishedProduct(true);
  };

  const isBaseConversionUnit = values?.convertionUnit?.id === 4 || values?.convertionUnit?.name === 'Unit';
  const shouldShowConversionQtyFields = !!values?.convertionUnit && !isBaseConversionUnit;

  // Total cost is `values.total`. Denominator: if conversion unit is "Unit", use Quantity only;
  // otherwise (Sq Ft, etc.) use Quantity × conversion qty — same as the read-only "Total … Qty" field.
  const totalCostNum = parseFloat(String(values.total ?? '').replace(/,/g, ''), 10);
  const qtyInt = parseInt(values.qty, 10) || 0;
  const convQtyInt = parseInt(values.convertionQty, 10) || 0;
  const costPerUnitDivisor = isBaseConversionUnit
    ? qtyInt
    : shouldShowConversionQtyFields
      ? qtyInt * convQtyInt
      : qtyInt;

  const modalCostPerUnit =
    Number.isFinite(totalCostNum) &&
    Number.isFinite(costPerUnitDivisor) &&
    costPerUnitDivisor > 0
      ? (totalCostNum / costPerUnitDivisor).toFixed(2)
      : '0';
  useEffect(() => {
    // When conversion unit is the base "Unit", conversion qty is always 1.
    if (!isBaseConversionUnit) return;
    if (parseInt(values.convertionQty, 10) !== 1) setFieldValue('convertionQty', 1);
  }, [isBaseConversionUnit, values.convertionQty, setFieldValue]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = slicedData?.map((n) => n.id);
      const newSelectedNames = slicedData?.map((n) => n.name);
      setSelected(newSelecteds);
      setSelectedNames(newSelectedNames);
      return;
    }
    setSelected([]);
    setSelectedNames([]);
  };

  const handleClick = (event, id,name) => {
    const selectedIndex = selected?.indexOf(id);
    const selectedNameIndex = selectedNames?.indexOf(name);
    let newSelected = [];
    let newselectedNames = [];
    if (selectedIndex === -1) {
      newSelected = newSelected?.concat(selected, id);
      newselectedNames = newselectedNames?.concat(selectedNames, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected?.concat(selected?.slice(1));
      newselectedNames = newselectedNames?.concat(selectedNames?.slice(1));
    } else if (selectedIndex === selected?.length - 1) {
      newSelected = newSelected?.concat(selected?.slice(0, -1));
      newselectedNames = newselectedNames?.concat(selectedNames?.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected?.concat(selected?.slice(0, selectedIndex), selected?.slice(selectedIndex + 1));
      newselectedNames = newselectedNames?.concat(selectedNames?.slice(0, selectedNameIndex), selectedNames?.slice(selectedNameIndex + 1));
    }
    setSelected(newSelected);
    setSelectedNames(newselectedNames);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setSelected([]);
    setSelectedNames([]);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    setPage(0)
  };

  const handleFilterBySource = (event) => {
    setFilterSource(event);
    setPage(0)
  };

  const handleDeleteUser = (userId) => {
    dispatch(deleteUser(userId));
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - ProductList?.length) : 0;
  // const filteredUsers = applySortFilter(ProductList?.filter(item => item.qty > 0), getComparator(order, orderBy), filterName, filterSource);
  const filteredUsers = applySortFilter(ProductList, getComparator(order, orderBy), filterName, filterSource);
  const slicedData = filteredUsers?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const isUserNotFound = filteredUsers?.length === 0;

  return (
    <>
      <Container sx={{ pt: 1, px: 0 }}>
        <Card>
          {!fromListTransfer && (
            <>
          <Stack direction="row" justifyContent="start" spacing={3} sx={{ px: 2, pt: 0.5, pb: 1 }}>
          <InventoryStockComparison materialId={editId} refreshData={refreshData} embedded />
         </Stack>
          <MaterialInventoryToolbar 
              numSelected={selected?.length} 
              filterName={filterName} 
              onFilterName={handleFilterByName}
              filterSource={filterSource}
              onFilterSource={handleFilterBySource}
              selectedName={selectedNames} 
              selected={selected} 
              onDelete={() => {setSelected([]);setPage(0);}}
              item="finished products"
              leadingAction={
                !viewFinishedProducts ? (
                  <Button
                    disabled={explodedPermissions?.some(permission => ['Add Finished Product'].includes(permission)) ? false : true}
                    onClick={handleOpenAddFinishedProduct}
                    variant="contained"
                    startIcon={<Icon icon={plusFill} />}
                  >
                    Add Finished Product
                  </Button>
                ) : null
              }
            />
          </>
          )}
          <Scrollbar>
          <Stack direction="row" alignItems="center" justifyContent="start" spacing={3} sx={{p:3}}>
            <Switch
              checked={printerSettings}
              onChange={()=>{setPrinterSettings(!printerSettings)}}
            />
            <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              Print Settings
              <Box
                component="span"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  '@keyframes rotate': {
                    '0%': { 
                      transform: 'rotate(0deg)' 
                    },
                    '100%': { 
                      transform: 'rotate(360deg)' 
                    }
                  },
                  animation: 'rotate 3s linear infinite',
                }}
              >
                <Icon 
                  icon={settingsOutline} 
                  width={28} 
                  height={28}
                  style={{ color: '#0daad9' }}
                />
              </Box>
            </Typography>
            <Tooltip
              arrow
              placement="right"
              title={
                <Typography variant="body2" sx={{ maxWidth: 320 }}>
                  Unit cost, total cost, and other amounts in this list may appear rounded (e.g. 5.98).
                  The value shown on hover is the full precision amount stored in the system and used for
                  inventory, refill, and job cost calculations.
                </Typography>
              }
            >
              <IconButton
                size="small"
                aria-label="About displayed amounts"
                sx={{
                  color: '#ff3b3b',
                  p: 0,
                  minWidth: 28,
                  minHeight: 28,
                  '@keyframes amountHelpAttention': {
                    '0%, 20%, 100%': {
                      transform: 'translate3d(0, 0, 0) rotate(0deg) scale(1)',
                      filter: 'drop-shadow(0 0 3px rgba(255, 59, 59, 0.55))',
                    },
                    '57%': {
                      transform: 'translate3d(0, -7px, 0) rotate(-12deg) scale(1.1)',
                      filter: 'drop-shadow(0 0 12px rgba(255, 59, 59, 1))',
                    },
                    '59%': {
                      transform: 'translate3d(-3px, 0, 0) rotate(12deg) scale(1.08)',
                    },
                    '61%': {
                      transform: 'translate3d(3px, -4px, 0) rotate(-10deg) scale(1.1)',
                    },
                    '63%': {
                      transform: 'translate3d(-3px, 0, 0) rotate(10deg) scale(1.06)',
                    },
                    '65%': {
                      transform: 'translate3d(3px, -2px, 0) rotate(-8deg) scale(1.08)',
                    },
                    '67%': {
                      transform: 'translate3d(0, 0, 0) rotate(0deg) scale(1)',
                      filter: 'drop-shadow(0 0 10px rgba(255, 59, 59, 0.95))',
                    },
                  },
                  animation: 'amountHelpAttention 2.8s ease-in-out infinite',
                  '&:hover': {
                    animationPlayState: 'paused',
                    transform: 'translate3d(0, 0, 0) rotate(0deg) scale(1)',
                    filter: 'drop-shadow(0 0 8px rgba(255, 59, 59, 0.9))',
                  },
                }}
              >
                <Icon icon={questionMarkCircleOutline} width={28} height={28} />
              </IconButton>
            </Tooltip>
          </Stack>  
            <TableContainer ref={tableContainerRef} sx={{ minWidth: 800 }}>
              <Table>
              <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={slicedData?.length}
                  numSelected={selected?.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                {loading ? (
                  <CircularProgress color="primary" variant="indeterminate" />
                ) : (
                  <>
                  {slicedData?.map((row) => {
                    let { id,	barcode, name, timestamp,unit_qty,convertion_unit,convertion_qty, status, unit_cost,qty,total_cost, authorized_by,source,vendor,avaliable_partial, product_markup, markup: rowRetailMarkup } = row;
                    const costPerUnit =
                      Number(qty) > 0
                        ? Number(Number(total_cost || 0) / Number(qty || 1))
                        : 0;

                    const markup =
                      retailMarkup !== undefined && retailMarkup !== null && retailMarkup !== ''
                        ? Number(retailMarkup) || 0
                        : Number(product_markup) || Number(rowRetailMarkup) || 0;

                    const markupAmount = (costPerUnit * markup) / 100;

                    const sellingPrice = costPerUnit + markupAmount;
                    const isWithinLast24Hours = (timestamp) => {
                      const twentyFourHoursAgo = moment().subtract(24, 'hours');
                      const timestampMoment = moment.unix(timestamp); // Convert timestamp to moment object
                      return timestampMoment.isAfter(twentyFourHoursAgo);
                    };
                    const withinLast24Hours = isWithinLast24Hours(timestamp);
                    const isItemSelected = selected?.indexOf(id) !== -1;
                const convertionUnitName = convertion_unit ? UNITS?.find((item) => item.id === convertion_unit)?.short_name : '';
                    return (
                      <TableRow
                        hover
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" onClick={handleScrollRight}>
                          <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} >
                            <ArrowForwardIos color="#ffffff" sx={{width:"20px",fontSize:'1rem'}}/>
                          </IconButton>
                        </TableCell>
                        <TableCell>
                        
                          {withinLast24Hours && <Label
                            variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                            color={ 'info' }
                          >
                            New
                          </Label>}
                        </TableCell>
                        <TableCell align="center">  
                          <Tooltip title={barcode}>                                     
                            <QRCode
                              value={`${PATH_DASHBOARD.products.viewFinished}/${id}`}
                              style={{ cursor: 'pointer' }}                             
                              size={70}
                              bgColor={'#ffffff'}  
                              fgColor={'#000000'}
                            />
                          </Tooltip>
                        </TableCell>
                        <Tooltip title={name || ""}>
                        <TableCell component="th" scope="row" padding="none"
                          sx={{
                            cursor: 'pointer',
                            maxWidth: 130, // Adjust as necessary
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            // display: 'block', // Change display to 'block'
                          }}
                        >
                          {/* <Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
                            <Typography variant="subtitle2" noWrap> */}
                              {name}
                            {/* </Typography>
                          </Stack> */}
                        </TableCell>
                        </Tooltip>
                        {fromTask ? <TableCell align="center" />  : <Tooltip title={qty > 0 ? (( (total_cost || 0)  / (qty || 1)) || 0) : 0}><TableCell align="center">{qty > 0 ? (( (total_cost || 0)  / (qty || 1)).toFixed(2) || 0) : 0}</TableCell></Tooltip>} 
                        {fromTask ? <TableCell align="center" />  :   <Tooltip title={sellingPrice}>
                          <TableCell align="center" sx={{ color: theme.palette.mode === 'light' ? '#ff748d' : '#ffc0cb' }}>
                            {sellingPrice.toFixed(2)}
                          </TableCell>
                        </Tooltip>}   
                        {fromTask ? <TableCell align="center" />  : <Tooltip title={unit_cost ? unit_cost : "0.00"}><TableCell align="center">{unit_cost ? unit_cost?.toFixed(2) : 0.00}</TableCell></Tooltip>}
                        {/* <TableCell align="center">{unit_qty}</TableCell> */}
                        <TableCell align="center">{`${unit_qty ? unit_qty?.toFixed(2) : 0.00} ${convertionUnitName ? `(${qty ? qty?.toFixed(2) : 0.00} ${convertionUnitName})` : ''}` }</TableCell>
                        {fromTask ? <TableCell align="center" />  : <TableCell align="center">{total_cost ? total_cost?.toFixed(2) : 0.00}</TableCell>}                                         
                        {fromTask ? <TableCell align="center" />  : <TableCell align="center">{source==0 ? 'Inventory' : 'Vendor'}</TableCell>}
                          
                      {fromTask ? <TableCell align="center" />  : <Tooltip title={vendor || ""}>

                          <TableCell
                            align="center"
                            sx={{
                              cursor: 'pointer',
                              maxWidth: 150, // Adjust as necessary
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              // display: 'block', // Change display to 'block'
                            }}
                          >
                              {vendor}
                          </TableCell>
                        </Tooltip>}
                        <TableCell align="center">
                          <Label
                            variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                            color={avaliable_partial === 1 ? 'success' : 'error'}
                          >
                            {avaliable_partial === 1 ? 'Available' : 'Not Available'}
                          </Label>
                        </TableCell>  
                        {/* <TableCell align="center">{moment.unix(timestamp).format('DD-MM-YYYY')}</TableCell> */}
                        <TableCell align="right">
                        <FinishedProductmenu
                          url={`${BASE_URL}view-finished-products/`}
                           id={id}  
                           name={name}  
                           barcode={barcode}
                           vpt_number={vpt_number}
                           description={description}
                           vendor={vendor}
                           printerSettings={printerSettings}
                        />
                        </TableCell>
                       
                        <TableCell align="center">
                        {/* {(source === 0) ? <MaterialInventoryMenu onDelete={() => handleDeleteUser(id)} userName={name} id={id} status={status} fromFinishedProducts onEdit={(id)=>{setEditFinishedProductId(id);setOpenAddFinishedProduct(true) }} onRefresh={()=>{setRefreshData(!refreshData)}} /> : ''} */}
                        {(source === 0) ?
                            ((viewFinishedProducts && !fromListTransfer)
                              ? '' 
                              : <MaterialInventoryMenu editId={editId} unitName={unitName} showRefill={true} barcode={barcode} unit={unit} onDelete={() => handleDeleteUser(id)} userName={name} unit_cost={unit_cost} qty={qty} id={id} status={status} fromFinishedProducts onEdit={(id)=>{setEditFinishedProductId(id);setOpenAddFinishedProduct(true) }} onRefresh={()=>{setRefreshData(!refreshData)}} vpt_number={vpt_number} hideMoveToPartial={hideMoveToPartial} isCatalog={isCatalog} datas={row} fromListTransfer={fromListTransfer}/>
                            )
                          : ((viewFinishedProducts && !fromListTransfer)
                              ? '' 
                              :(isCatalog) ? '' : <MaterialInventoryMenu editId={editId} unitName={unitName} barcode={barcode} unit={unit} userName={name} id={id} status={status} unit_cost={unit_cost} qty={qty} fromFinishedProducts onEdit={(id)=>{setEditFinishedProductId(id);setOpenAddFinishedProduct(true) }} onRefresh={()=>{setRefreshData(!refreshData)}} vpt_number={vpt_number} hideMoveToPartial={hideMoveToPartial} isCatalog={isCatalog} datas={row} fromListTransfer={fromListTransfer}/>
                            )
                        }
                        </TableCell>
                        <TableCell padding="checkbox" onClick={handleScrollLeft}>
                          <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} >
                            <ArrowBackIos color="#ffffff" sx={{width:"20px",ml:0.5,fontSize:'1rem'}}/>
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                  </>
                    )}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} msg="Finished Products"/>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[10, 25, 50,100]}
            component="div"
            count={filteredUsers?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
      <Modal
        modalTitle={editFinishedProductId ? 'Edit Finished Product' : 'Add Finished Product'}
        open={openAddFinishedProduct}
        handleClose={handleCloseFinishedProductModal}
      >
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} md={8}>
                <Stack spacing={3}>
                  <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
                    <TextField
                      fullWidth
                     label={unitName ? unitName + ' Cost ($)' : 'Unit Cost ($)'}
                      type="number"
                      onKeyPress={(event) => {
                        // console.log('errorFieldId------',errorFieldId)
                        // if (event.key === '0' && event.target.value === '0' ) {
                        //   event.preventDefault();
                        // }
                        // if (event.key === '0' && event.target.value === '' ) {
                        //   event.preventDefault();
                        // }
                        if (event.key === '-' ) {
                          event.preventDefault();
                        }
                        if (event.key === '+' ) {
                          event.preventDefault();
                        }
                      }}
                      onWheel={(e) => e.target.blur()}
                      onKeyDown={(event) => {
                        const value = parseFloat(event.target.value) || 0;
                    
                        if (event.key === 'ArrowDown' && value <= 0) {
                          event.preventDefault();
                        }
                      }}
                      // {...getFieldProps('unitCost')}
                      InputLabelProps={{ shrink: true }}
                      value={values.unitCost}
                      // disabled
                      onChange={(e)=>{
                        setFieldValue('unitCost',e.target.value);
                        const qtyForCalc = parseInt(values.qty, 10) || 0;
                        if(unitName === 'Unit') {
                          setFieldValue('total',(e.target.value * qtyForCalc)?.toFixed(2)) 
                        }else{
                          setFieldValue('total',(e.target.value * (unitQty * qtyForCalc))?.toFixed(2))
                        }
                      }}
                      error={Boolean(touched.unitCost && errors.unitCost)}
                      helperText={touched.unitCost && errors.unitCost}
                    />
                    {/* {unitName === 'Unit' ? null :
                    <TextField
                      fullWidth
                      label={'Number of '+unitName}
                      type="number"
                      value={unitQty || 0}
                      // {...getFieldProps('unit_qty')}
                      error={Boolean(touched.unit_qty && errors.unit_qty)}
                      helperText={touched.unit_qty && errors.unit_qty}
                      // InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                      // InputProps={{ readOnly:true }}
                    />} */}
                    <TextField
                      fullWidth
                      label="Quantity"
                      type="number"
                      onKeyPress={(event) => {
                        // console.log('errorFieldId------',errorFieldId)
                        // if (event.key === '0' && event.target.value === '0' ) {
                        //   event.preventDefault();
                        // }
                        // if (event.key === '0' && event.target.value === '' ) {
                        //   if ( event.target.value === '' ) {
                        //   event.preventDefault();
                        // }
                        if (event.key === '-' ) {
                          event.preventDefault();
                        }
                        if (event.key === '+' ) {
                          event.preventDefault();
                        }
                        if (event.key === '.' || event.key === 'e' || event.key === 'E') {
                          event.preventDefault();
                        }
                      }}
                      onWheel={(e) => e.target.blur()}
                      // {...getFieldProps('qty')}
                      onKeyDown={(event) => {
                        const value = parseFloat(event.target.value) || 0;
                    
                        if (event.key === 'ArrowDown' && value <= 0) {
                          event.preventDefault();
                        }
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={values.qty}
                      onChange={(e)=>{
                        const qtyValue = parseInt(e.target.value, 10);
                        const finalQty = Number.isNaN(qtyValue) ? '' : qtyValue;
                        const qtyForCalc = Number.isNaN(qtyValue) ? 0 : qtyValue;
                        setFieldValue('qty', finalQty);

                        const unitCostForCalc = parseFloat(values.unitCost) || 0;
                        if (unitName === 'Unit') {
                          setFieldValue('total', (unitCostForCalc * qtyForCalc)?.toFixed(2));
                        } else {
                          setFieldValue('total', (unitCostForCalc * (unitQty * qtyForCalc))?.toFixed(2));
                        }
                      }}
                      error={Boolean(touched.qty && errors.qty)}
                      helperText={touched.qty && errors.qty}
                    />
                    <Autocomplete
                      fullWidth
                      id="finished-product-conversion-unit"
                      options={UNITS}
                      value={values.convertionUnit}
                      onChange={(event, newValue) => {
                        setFieldValue('convertionUnit', newValue);
                        if (newValue?.id === 4 || newValue?.name === 'Unit') {
                          setFieldValue('convertionQty', 1);
                        } else if (!editFinishedProductId) {
                          setFieldValue('convertionQty', 1);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          // required
                          label="Select a conversion unit"
                          error={Boolean(touched.convertionUnit && errors.convertionUnit)}
                          helperText={touched.convertionUnit && errors.convertionUnit}
                        />
                      )}
                      getOptionLabel={(option) => option?.name ? option.name : ''}
                    />
                    {shouldShowConversionQtyFields && (
                      <>
                        <TextField
                          fullWidth
                          required
                          label={values.convertionUnit ? `${values.convertionUnit?.short_name} Qty ${editData?.partial==0?'each':''}` : `Conversion Qty ${editData?.partial==0?'each':''}`}
                          type="number"
                          inputProps={{ min: 1, step: 1 }}
                          onKeyPress={(event) => {
                            if (
                              event.key === '-' ||
                              event.key === '+' ||
                              event.key === 'e' ||
                              event.key === 'E' ||
                              event.key === '.'
                            ) {
                              event.preventDefault();
                            }
                          }}
                          onKeyDown={(event) => {
                            if (event.key === '-' || event.key === 'Subtract') {
                              event.preventDefault();
                            }
                            const currentValue = parseInt(event.target.value, 10) || 0;
                            if (event.key === 'ArrowDown' && currentValue <= 1) {
                              event.preventDefault();
                            }
                          }}
                          value={values.convertionQty}
                          onChange={(e) => {
                            const raw = e.target.value;
                            if (raw === '') {
                              setFieldValue('convertionQty', '');
                              return;
                            }
                            if (/^-/.test(raw)) {
                              return;
                            }
                            const parsedValue = parseInt(raw, 10);
                            if (Number.isNaN(parsedValue) || parsedValue <= 0) {
                              return;
                            }
                            setFieldValue('convertionQty', parsedValue);
                          }}
                          error={Boolean(touched.convertionQty && errors.convertionQty)}
                          helperText={touched.convertionQty && errors.convertionQty}
                        />
                        <TextField
                          fullWidth
                           label={values.convertionUnit ? ` Total ${values.convertionUnit?.short_name} Qty` : 'Total Qty'}
                          type="number"
                          value={(parseInt(values.qty, 10) || 0) * (parseInt(values.convertionQty, 10) || 0)}
                          InputProps={{ readOnly: true }}
                        />
                      </>
                    )}
                    <TextField
                      fullWidth
                      label="Total Cost ($)"
                      type="number"
                      {...getFieldProps('total')}
                      error={Boolean(touched.total && errors.total)}
                      helperText={touched.total && errors.total}
                      InputLabelProps={{ shrink: true, style: { color: theme.palette.text.primary } }}
                      InputProps={{ readOnly:true }}
                    />
                     <TextField
                        fullWidth
                        label="cost per unit"
                        value={modalCostPerUnit}
                        InputProps={{ readOnly:true }}
                      />
                    {editFinishedProductId && (
                      <TextField
                        fullWidth
                        required
                        label="Reason"
                        {...getFieldProps('inventoryReason')}
                        error={Boolean(touched.inventoryReason && errors.inventoryReason)}
                        helperText={touched.inventoryReason && errors.inventoryReason}
                      />
                    )}
                  </Stack>

                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                    <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                      {editFinishedProductId ? 'Save Changes' :'Add Finished Product'}
                    </LoadingButton>
                    <Button variant="outlined" onClick={handleCloseFinishedProductModal} sx={{ marginLeft: '10px' }}>
                      Cancel
                    </Button>
                  </Box>
                </Stack>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </Modal>
      <InventoryUnitCostWarningDialog
        open={showUnitCostWarningDialog}
        onClose={() => setShowUnitCostWarningDialog(false)}
        onConfirm={handleConfirmUnitCostWarning}
      />
      <InventoryUnitCostWarningDialog
        open={showConvertionQtyWarningDialog}
        onClose={() => setShowConvertionQtyWarningDialog(false)}
        onConfirm={handleConfirmConvertionQtyWarning}
        title={convertionQtyWarningContent.title}
        message={convertionQtyWarningContent.message}
        continueQuestion={convertionQtyWarningContent.continueQuestion}
        highlightText={convertionQtyWarningContent.highlightText}
      />
    </>
  );
}
